import React from 'react';

export default () =>{

    return	(
        <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.5C4.48564 0.5 0 4.98563 0 10.5C0 16.0144 4.48564 20.5 10 20.5C15.5144 20.5 20 16.0144 20 10.5C20 4.98563 15.5144 0.5 10 0.5ZM10 1.92857C14.7423 1.92857 18.5714 5.7577 18.5714 10.5C18.5714 15.2423 14.7423 19.0714 10 19.0714C5.25769 19.0714 1.42857 15.2423 1.42857 10.5C1.42857 5.7577 5.25769 1.92857 10 1.92857ZM10 3.11905C9.60552 3.11905 9.28571 3.43886 9.28571 3.83333V10.5C9.28571 10.7642 9.42967 10.994 9.64286 11.1175L15.0074 14.2128C15.349 14.41 15.7849 14.294 15.9821 13.9524C16.1794 13.6108 16.0634 13.1749 15.7217 12.9777L10.7143 10.0908V3.83333C10.7143 3.43886 10.3945 3.11905 10 3.11905Z" fill="black"/>
        </svg>
    )
}